import { all } from "redux-saga/effects";

import { lookupsSaga } from "./lookups";
import { userSaga } from "./user";
import { projectsSaga } from "./projects";
import { earningsSaga } from "./earnings";
import { ratesSaga } from "./rates";
import { invoicesSaga } from "./invoices";

export default function* rootSaga() {
  yield all([
    lookupsSaga(),
    userSaga(),
    projectsSaga(),
    earningsSaga(),
    ratesSaga(),
    invoicesSaga(),
  ]);
}
